import React, { useState, useEffect } from 'react';
import axiosRestaurantInstance from './AxiosRestaurantInstance';
import './css/Payment.css';

const Payment = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user ? user.userId : null;
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState('');
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('Token')
    const fetchRestaurants = async () => {
      if (userId) {
        try {
          const response = await axiosRestaurantInstance.get(`/user_restaurant/${userId}`,{
            headers: {
              'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
          }
          });
          setRestaurants(response.data);
        } catch (error) {
          console.error('Error fetching restaurants:', error);
        }
      }
    };

    fetchRestaurants();
  }, [userId]);

  const handleSelectChange = async (event) => {
    const restaurantId = event.target.value;
    setSelectedRestaurant(restaurantId);
    fetchPaymentsData(restaurantId);
  };
  const token = localStorage.getItem('Token')
  const fetchPaymentsData = async (restaurantId) => {
    try {
      const response = await axiosRestaurantInstance.get(`/get_orders_all/${restaurantId}`,{
        headers: {
          'Authorization': `Bearer ${token}`, // Set the token in the Authorization header
      }
      });
      const orders = response.data.orders;
      processPaymentData(orders);
    } catch (error) {
      console.error('Error fetching payment data:', error);
    }
  };

  const processPaymentData = (orders) => {
    // const today = new Date().toISOString().split('T')[0];
    const paymentData = {};

    orders.forEach((order) => {
      const orderDate = order.createdDate.split(' ')[0];
      const status = order.orderStatus;

      if (status === 'IN TRANSIT' || status === 'DELIVERED') {
        const amount = parseFloat(order.totalPrice);

        if (!paymentData[orderDate]) {
          paymentData[orderDate] = { date: orderDate, totalOrders: 0, totalAmount: 0 };
        }
        paymentData[orderDate].totalOrders += 1;
        paymentData[orderDate].totalAmount += amount;
      }
    });

    const sortedPayments = Object.values(paymentData)
      .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort by date in descending order
      .map((data) => ({
        ...data,
        totalAmount: data.totalAmount.toFixed(2),
      }));

    setPayments(sortedPayments);
  };

  return (
    <div className="payment-container">
      <label htmlFor="restaurant-select">Select Restaurant:</label>
      <select
        id="restaurant-select"
        className="today-order-select"
        value={selectedRestaurant}
        onChange={handleSelectChange}
      >
        <option value="">-- Select a restaurant --</option>
        {restaurants.length > 0 ? (
          restaurants.map((restaurant) => (
            <option key={restaurant.RestaurantId} value={restaurant.RestaurantId}>
              {restaurant.RestaurantName}
            </option>
          ))
        ) : (
          <option disabled>No restaurants available</option>
        )}
      </select>

      {selectedRestaurant && (
        <div>
          <table className="payment-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Total No. of Orders</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {payments.length > 0 ? (
                payments.map((payment, index) => (
                  <tr key={index}>
                    <td>{payment.date}</td>
                    <td>{payment.totalOrders}</td>
                    <td>{payment.totalAmount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Payment;
